import ShopArticleTaxHistoryResourceListResultModel from '../../generated/types/model/resource/ShopArticleTaxHistoryResourceListResultModel';

export default class ShopArticleTaxHistoryResourceListResultViewModel extends ShopArticleTaxHistoryResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
